{
    "NAME": "DatabaseLanguage",
    "Database_Section_MaintenanceInterval_Title": "Database Maintenance Interval",
    "Database_Section_MaintenanceInterval_Description": "Configure a daily period during which the application suspends database activity. The start and end times are interpreted as UTC.",
    "Database_Field_MaintenanceInterval_Enabled": "Suspend Database Activity Daily",
    "Database_Field_MaintenanceInterval_TimeStart": "Start Time (UTC)",
    "Database_Field_MaintenanceInterval_TimeEnd": "End Time (UTC)",
    "Database_Field_MaintenanceInterval_DaysOfWeek": "Days of Week",
    "Database_Day_Monday": "Monday",
    "Database_Day_Tuesday": "Tuesday",
    "Database_Day_Wednesday": "Wednesday",
    "Database_Day_Thursday": "Thursday",
    "Database_Day_Friday": "Friday",
    "Database_Day_Saturday": "Saturday",
    "Database_Day_Sunday": "Sunday",
    "Database_Action_Apply": "Apply",
    "Database_Action_Cancel": "Cancel",
    "Database_Action_Refresh": "Refresh",
    "Database_Save_Success": "Database settings saved.",
    "Database_Save_Error": "Unable to save database settings.",
    "Database_Load_Error": "Unable to load database settings.",
    "Database_Warning_ReadOnly": "You can view these settings but you do not have permission to change them. Only system-wide administrators with root access can edit database settings.",
    "Database_Warning_Unavailable": "Database settings are currently unavailable. The database may not have been accessible when the application started."
}
